<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование документа, подтверждающего полномочия представителя Пользователя ЭПЭ') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <v-row>
          <v-col>
            <ValidationObserver ref="authorizationDocument">
              <user-authorization-document-info
                  v-if="isUserAuthorizationDocument"
                  ref="authorizationDocumentInfo"
                  :authorization-document-info="currentAuthorizationDocument"
                  @keydown.native.enter="focusOnBtn('continueBtn')" />
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            ref="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import UserAuthorizationDocumentInfo from '@/components/reused/authorizationDocuments/UserAuthorizationDocumentInfo.vue'
  import { DOCUMENT_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { AUTHORIZATION_DOCUMENTS_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      UserAuthorizationDocumentInfo,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            documentId: null,
            documentType: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(AUTHORIZATION_DOCUMENTS_MANAGEMENT.NAMESPACE, {
        currentAuthorizationDocument: state => (state[AUTHORIZATION_DOCUMENTS_MANAGEMENT.STATE.CURRENT_AUTHORIZATION_DOCUMENT] || { })
      }),
      isUserAuthorizationDocument () {
        return this.dialogProp.documentType === DOCUMENT_TYPES.USER_AUTHORIZATION_DOCUMENT
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (vm.dialogProp.documentId) {
          vm.getAuthorizationDocumentAdmin()
        }
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(AUTHORIZATION_DOCUMENTS_MANAGEMENT.NAMESPACE, {
        getAuthorizationDocumentAdminAction: AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.GET_AUTHORIZATION_DOCUMENT_ADMIN,
        updateAuthorizationDocumentAction: AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.UPDATE_AUTHORIZATION_DOCUMENT,
        clearAuthorizationDocumentAdminAction: AUTHORIZATION_DOCUMENTS_MANAGEMENT.ACTIONS.CLEAR_AUTHORIZATION_DOCUMENT_ADMIN
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearAuthorizationDocumentAdminAction()
          ])
      },
      continueOperation: async function () {
        const result = await this.$refs.authorizationDocument.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          const authorizationDocument = await this.$refs.authorizationDocumentInfo.getData()
          await this.updateAuthorizationDocumentAction({
            documentType: this.dialogProp.documentType,
            documentId: this.dialogProp.documentId,
            authorizationDocument
          })
          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getAuthorizationDocumentAdmin: async function () {
        this.isLoading = true
        try {
          await this.getAuthorizationDocumentAdminAction({
            documentType: this.dialogProp.documentType,
            documentId: this.dialogProp.documentId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
